import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_149: FaireProductEntity = {
  token: "legacy_prod_abbott-149",
  type: "product",
  name: "Chipmunk Door Wedge-Dark Brown",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e448e5ed0af4494245b25c9d86aadf07641d621c9077f41d07b84de838d3d189.jpeg",
  priceDollars: 24,
  subcategory: "Outdoor Decor",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
